/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import _ from 'underscore';
import CheckoutContainer from '../../components/CheckOutContainer/CheckoutContainer';
import ContactDetailsWidget from '../../components/ContactDetailsWidget/ContactDetailsWidget';
import DeliveryTimeWidget from '../../components/DeliveryTimeWidget/DeliveryTimeWidget';
import DropoffMap from '../../components/DropoffMap/DropoffMap';
import Input from '../../components/Input/Input';
import LocationAccessCheckoutReminder from '../../components/LocationAccessCheckoutReminder/LocationAccessCheckoutReminder';
import * as reduxStore from "../../redux/store";
import cmsKeys from "../../shared/constants/cms";
import * as cms from "../../shared/repos/cms/cms";
import { milesToMeters } from '../../shared/utilities/distance';
import { handleFormInput } from '../../shared/utilities/validations';
import GiftRecipient from './GiftRecipient/GiftRecipient';
import Instructions from './Instructions/Instructions';

import checkoutContainerStyles from "../../components/CheckOutContainer/CheckoutContainer.module.css";
import LocationLabelSelectorWidget from '../../components/LocationLabelSelector/LocationLabelSelectorWidget';
import subscription from '../../shared/constants/subscription';
import PickupInstructions from './Instructions/PickupInstructions';
import {
  getCheckoutPartProps,
  isReviewOrderBrandRefresh,
} from './reviewOrderBrandRefreshClasses';
import styles from './ReviewOrder.module.css';

export const returnRadioOptions = (chosenIndex, options, onChosen) => {
  const brandRefresh = isReviewOrderBrandRefresh();
  return (
    <div
      className={styles.optionsContainer}
      data-part={getCheckoutPartProps('tip-options')}
    >
      {options.map((option, index) => {
        const isChosen = chosenIndex === index;
        let optionClassName;
        if (brandRefresh) {
          optionClassName = [
            styles.tipPill,
            isChosen ? styles.chosen : null,
          ]
            .filter(Boolean)
            .join(' ');
        } else {
          optionClassName = `
              h-[60px] dark:text-white font-montserratMedium
              ${
                isChosen ?
                `${styles.chosen} border-none bg-border dark:bg-button text-white` :
                'border-lightDry dark:border-darkDry border-[1px] bg-white dark:bg-dark text-dark'}`;
        }
        return (
          <div
            key={option}
            role='button'
            tabIndex={0}
            onClick={() => onChosen(index)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onChosen(index);
              }
            }}
            className={optionClassName}
            data-part={getCheckoutPartProps('tip-pill')}
            data-selected={brandRefresh && isChosen ? 'true' : undefined}
          >
            {`${option}`}
          </div>
        );
      })}
    </div>
  );
};

/**
 * Returns line cost element UI
 * @param {String} label
 * @param {Number} price
 * @param {Boolean} isDiscount
 * @param currency
 * @param {String} lineCostType
 * @param {Boolean} isTotal
 * @param {Boolean} isLoyaltyPoints
 * @param {Number} strikeThroughPrice
 * @param {Boolean} showDealLabel
 */
export const returnLineCost = (label, price, isDiscount, currency, lineCostType, isTotal = false, isLoyaltyPoints = false, strikeThroughPrice = null, showDealLabel = false) => {
  const store = reduxStore.store.getState();

  let customLabel = label;
  let orderTotalsJson = [];
  if (store) {
    const { orderTotalsTitles } = store.orderTotalsTitles;
    orderTotalsJson = JSON.parse(orderTotalsTitles);
  }

  if (orderTotalsJson && orderTotalsJson[label] !== undefined) {
    customLabel = orderTotalsJson[label];
  }

  let value = Number.isNaN(parseFloat(price))
      ? price : `${isDiscount && price > 0? '-' : ''}${currency.symbol}${parseFloat(price).toFixed(2)}`;
  if(isLoyaltyPoints) {
    value = `${price} pts`;
  }

  let strikeThroughValue = null;
  if (strikeThroughPrice !== null && strikeThroughPrice !== undefined) {
    strikeThroughValue = Number.isNaN(parseFloat(strikeThroughPrice))
      ? strikeThroughPrice : `${currency.symbol}${parseFloat(strikeThroughPrice).toFixed(2)}`;
  }

  // Figma 9682:47601 — "Coupon: CODE" / "Giftcard: CODE": prefix Bold, code Medium
  const brandRefreshDiscountMatch =
    isReviewOrderBrandRefresh() &&
    typeof customLabel === 'string' &&
    customLabel.match(/^(Coupon|Giftcard):\s*(.+)$/i);

  return (
    <>
      {customLabel ? (
        <div
          className={`${styles.lineCost} text-dark dark:text-white `}
          data-total-label={customLabel}
          data-total-value={value}
          data-line-cost-type={lineCostType}
          key={label}
        >
          {brandRefreshDiscountMatch ? (
            <p>
              <span data-part="discount-prefix">
                {`${brandRefreshDiscountMatch[1]}: `}
              </span>
              <span data-part="discount-code">
                {brandRefreshDiscountMatch[2]}
              </span>
            </p>
          ) : (
            <p className={`${isTotal ? 'font-bold' : ''}`}>{customLabel}</p>
          )}
          {strikeThroughValue ? (
            <p className="flex items-center gap-2">
              {showDealLabel && <span className={styles.dealLabel}>DEAL</span>}
              <span className={styles.lineThrough}>{strikeThroughValue}</span>
              <span>{value}</span>
            </p>
          ) : (
            <p>{value}</p>
          )}
        </div>
      )
        : <div />}
    </>
  );
};

const handleDeliveryAddressInput = (e, component, state) => {
  const {value} = e.target;
  const {setSaveCheckoutDetails} = component.props
  setSaveCheckoutDetails({'aptNo': value});
  handleFormInput(e, component, state);
}

/**
| * @param {React.Component} component
| */
const deliveryAddressAdditionalInfo = (component) => {
  const { userAddress, checkoutUpdated, checkout, userToken } = component.props;
  const orderStatusSubscription = _.find(
    component.state.customerSubscriptions,
    { keyField: subscription.subscriptionKeyField.ORDER_NOTIFICATION }
  );
  const { saveCheckoutDetails } = component.props.checkout;
  const apartmentPlaceholder = (cms.getValueByKey(cmsKeys.placeholders.checkoutDeliveryAddressApartment, component) || 'Add apartment#/suite#/dorm#')
    .replace(/<\/?[^>]+(>|$)/g, "");
  const address2Value = saveCheckoutDetails && saveCheckoutDetails.aptNo ? saveCheckoutDetails.aptNo : component.state.address2;
  const { dropoffOrigin, dropoffCandidate, dropoffValid, dropoffDistance } = component.state;
  const DROPOFF_RADIUS_MILES = 0.25;
  const radiusMeters = milesToMeters(DROPOFF_RADIUS_MILES);
  const isBrandRefresh = isReviewOrderBrandRefresh();

  const giftRecipient = (
    <GiftRecipient
      orderStatusSubscription={orderStatusSubscription}
      completeOrderError={component.state.completeOrderError}
    />
  );

  const dropoffSection = dropoffOrigin ? (
    <div>
      <div
        className={checkoutContainerStyles.checkoutContainerLeft}
        data-part={getCheckoutPartProps('checkout-container-left')}
      >
        <p data-part={getCheckoutPartProps('checkout-container-header')}>
          Dropoff Location
        </p>
        <span
          className={
            isBrandRefresh
              ? undefined
              : 'text-sm text-gray-600 dark:text-gray-400'
          }
          data-part={getCheckoutPartProps('checkout-container-subheader')}
        >
          Drag the pin to adjust the dropoff location (within 
          {' '}
          {DROPOFF_RADIUS_MILES}
          {' '}
mi)
        </span>
      </div>
      <DropoffMap
        origin={dropoffOrigin}
        value={dropoffCandidate}
        radiusMeters={radiusMeters}
        onChange={component.onDropoffChange}
      />
      {!dropoffValid && dropoffDistance > DROPOFF_RADIUS_MILES && (
        <p className="text-sm text-red-600 dark:text-red-400">
          Please choose a location within 
          {' '}
          {DROPOFF_RADIUS_MILES}
          {' '}
mi of your address
        </p>
      )}
    </div>
  ) : null;

  return (
    <div className={styles.deliveryAddressAdditionalInfo}>
      {/* Accordion trigger already shows title + address under brand refresh */}
      {!isBrandRefresh ? (
        <div className={checkoutContainerStyles.checkoutContainerLeft}>
          <p>Delivery Address</p>
          <span>
            {[userAddress.address1, userAddress.city, userAddress.state].join(', ')}
          </span>
        </div>
      ) : null}

      <Input
        inputId="addressApartment"
        handleInput={(e) => handleDeliveryAddressInput(e, component, 'address2')}
        value={address2Value}
        customContainerStyles={styles.inputContainer}
        placeholder=" "
        label={apartmentPlaceholder}
      />

      { userToken ? (
        <LocationLabelSelectorWidget
          defaultValue={userAddress?.savedLocation?.locationLabel || null}
          onChange={(label) => {
        checkoutUpdated({ ...checkout, locationLabel: label, });
      }}
        />
) : null }

      {/* Figma 9112:75967 — gift checkbox with address options, before dropoff */}
      {isBrandRefresh ? giftRecipient : null}

      {dropoffSection}

      {!isBrandRefresh ? giftRecipient : null}

    </div>
            );
}

// eslint-disable-next-line no-unused-vars
const onExpand = (expand) => {
  const { checkout, checkoutUpdated } = this.props;
  this.setState({ openForm: expand, isGift: expand });

  checkout.isGift = expand;
  checkoutUpdated(checkout);
}

/**
| * Returns delivery details sub UI
| * @param {React.Component} component
| */
export const deliveryRendering = (component) => {
  const { userAddress } = component.props;
  const { order, deliveryAddressOpen, dropoffDirty, dropoffValid, dropoffSaving } = component.state;
  
  const address = [
    userAddress.address1,
    userAddress.city,
    userAddress.state
  ].join(',')

  return (
    <div>
      <DeliveryTimeWidget
        className='selectDeliveryTime border-b-2 border-lightDry dark:border-darkDry text-dark dark:text-white'
        orderCode={order.code}
        header="Delivery Time"
        subHeader="Need delivery time"
        sectionHeader="Select a delivery time"
        onDefaultDeliveryTime={component.setDefaultDeliveryTime}
        component={component}
        completeOrderError={component.state.completeOrderError}
      />
      <CheckoutContainer
        header="Delivery Address"
        className='border-b-2 border-lightDry  dark:border-darkDry text-dark dark:text-white'
        subHeader={address}
        onExpand={(val) => component.onExpandDeliveryAddress(val)}
        expanded={deliveryAddressOpen}
        btnAction={dropoffDirty ? component.handleSetDropoffLocation : null}
        btnDisabled={!dropoffDirty || !dropoffValid || dropoffSaving}
        label="Set Dropoff Location"
      >
        {deliveryAddressAdditionalInfo(component)}
      </CheckoutContainer>

      <Instructions component={component} />
    </div>
  );
};

/**
 * Returns pick up details sub UI
 * @param {React.Component} component
 */
export const pickUpRenderings = component => {
  const { order } = component.state;

  return (
    <div>
      <CheckoutContainer
        header="Store Location"
        subHeader={
          order.store && order.store.address ? order.store.address : ''
        }
      />
      {order && order.store ? (
        <LocationAccessCheckoutReminder
          store={order.store}
          isChecked={component.state.locationAccessCheckoutConfirmed}
          onCheckedChange={component.onLocationAccessCheckoutChange}
        />
      ) : null}
      <DeliveryTimeWidget
        className='selectPickupTime'
        orderCode={order.code}
        header="Pickup Time"
        subHeader="Need pickup time"
        sectionHeader="Select a pickup time"
        onDefaultDeliveryTime={component.setDefaultDeliveryTime}
        component={component}
        completeOrderError={component.state.completeOrderError}
      />

      <ContactDetailsWidget
        setContactFormError={component.setContactFormError}
        completeOrderError={component.state.completeOrderError}
      />

      <PickupInstructions component={component} />
    </div>
  );
};
